import React from 'react';
import { Box, } from '@mui/material';
import { formatDateLong } from '../../../services/apiServices';


const CooPrintFirst = ({ invoiceData, companyBanks, shippingBooking, shippingmark, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = shippingmark?.productsList?.productName || '';
    const invoiceDate = formatDateLong(invoiceData?.createdAt || "");
    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';
    //booking
    const portOfLoading = shippingBooking?.portOfLoading || '';
    const portOfDestination = shippingBooking?.portOfDestination || '';

    const serialNo = invoiceData?.serialNo ?? '';
    const certificateNo = invoiceData?.certificateNo ?? '';
    const consignee = invoiceData?.consignee ?? '';
    const transportAndRoute = invoiceData?.transportAndRoute ?? '';
    const certifyingAuthority = invoiceData?.certifyingAuthority ?? '';
    const countryOrRegion = invoiceData?.countryOrRegion ?? '';
    const marksAndPackages = invoiceData?.marksAndPackages ?? '';
    const descriptionOfGoods = invoiceData?.descriptionOfGoods ?? '';
    const hsCode = invoiceData?.hsCode ?? '';
    const quantity = invoiceData?.quantity ?? '';
    const invoiceDetails = invoiceData?.invoiceDetails ?? '';
    const declarationByExporter = invoiceData?.declarationByExporter ?? '';
    const certification = invoiceData?.certification ?? '';


    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>
                <div style={{ position: 'relative', padding: '0px', marginTop: footer ? '0px' : '20px', }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            marginBottom: "10px"
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>COO Draft</p>
                    </div>

                    <table
                        cellPadding="8"
                        cellSpacing="0"
                        style={{
                            width: '100%',
                            textTransform: "capitalize",
                            fontSize: "10px",
                            borderCollapse: 'collapse',
                            border: '1px solid #5A5A5A',
                            verticalAlign: "top"
                        }}
                    >
                        <tbody>
                            <tr>
                                <td colSpan={2} style={{
                                    border: '1px solid #5A5A5A', width: '50%',
                                }}>
                                    <span  >1. Exporter</span> <br />
                                    <span style={{ fontWeight: "bold" }}>{companyName}</span> <br />
                                    {companyAddress && `${companyAddress},`}  <br />
                                    {[companyCity, companyState, companyCountry].filter(Boolean).join(', ')}
                                    {companyPincode && ` - ${companyPincode}`}

                                </td>
                                <td rowSpan={2} colSpan={3} style={{
                                    border: '1px solid #5A5A5A',
                                    verticalAlign: "top",
                                    width: '50%',

                                    padding: 8
                                }}>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '3px' }}>
                                            <span style={{ minWidth: '120px' }}>Serial No:</span>
                                            <span style={{ textTransform: 'uppercase' }}>{serialNo}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                            <span style={{ minWidth: '120px' }}>Certification No:</span>
                                            <span style={{ textTransform: 'uppercase' }}>{certificateNo}</span>
                                        </div>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        textAlign: 'center',
                                        padding: '10px'
                                    }}>
                                        <div style={{ textTransform: "uppercase", fontSize: "15px", padding: "20px" }}>
                                            <span>Certification OF origin</span> <br />
                                            <span>of</span>
                                            <br />
                                            <span>the People's Republic Of {companyCountry}</span> <br />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2} style={{ border: '1px solid #5A5A5A', }}>
                                    <span>2. Consignee</span> <br />
                                    <span style={{ fontWeight: "bold" }}>{customerName}</span> <br />
                                    <span>
                                        {billingStreet && `${billingStreet},`}
                                        <br />
                                        {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                        {billingPincode && ` - ${billingPincode}`}
                                    </span><br />
                                    <span >Email:</span> <span>{customerEmail}</span> <br />
                                    <span >Mobile:</span> <span>{customerMobile}</span>
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td colSpan={2} style={{ border: '1px solid #5A5A5A' }}>
                                    <span>3.Means Of Transport And Route</span> <br />
                                    <span>
                                        {transportAndRoute}
                                    </span>
                                    <br />
                                    <br />
                                </td>
                                <td rowSpan={2} colSpan={3} style={{ border: '1px solid #5A5A5A', verticalAlign: "top" }}>
                                    <span>5. For Certifying Authority use Only</span>
                                    <br />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2} style={{ border: '1px solid #5A5A5A', verticalAlign: "top" }}>
                                    <span>4. Country / Region of Destination </span>
                                    <br />
                                    <span> {countryOrRegion}</span>
                                    <br />
                                    <br />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table
                        cellPadding="8"
                        cellSpacing="0"
                        style={{
                            width: '100%',
                            textTransform: "capitalize",
                            fontSize: "10px",
                            borderCollapse: 'collapse',
                            border: '1px solid #5A5A5A',
                            verticalAlign: "top",
                            borderTop: '0'
                        }}
                    >
                        <tbody>
                            <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold" }}>
                                <td style={{ width: '30%', border: '1px solid #5A5A5A', borderTop: '0' }}>
                                    6. Marks and Numbers
                                </td>
                                <td style={{ width: '40%', border: '1px solid #5A5A5A', borderTop: '0' }}>
                                    7. Numbers and kind of packages; description of goods
                                </td>
                                <td style={{ width: '10%', border: '1px solid #5A5A5A', borderTop: '0' }}>
                                    8. H.S code
                                </td>
                                <td style={{ width: '10%', border: '1px solid #5A5A5A', borderTop: '0' }}>
                                    9. Quantity
                                </td>
                                <td style={{ width: '10%', border: '1px solid #5A5A5A', borderTop: '0' }}>
                                    10. Number and date of inv.
                                </td>
                            </tr>
                        </tbody>
                        <tbody style={{ height: "450px" }}>
                            <tr style={{ verticalAlign: "top" }}>
                                <td style={{ border: '1px solid #5A5A5A', }}>{marksAndPackages}</td>
                                <td style={{ border: '1px solid #5A5A5A' }}>{descriptionOfGoods}</td>
                                <td style={{ border: '1px solid #5A5A5A' }}>{hsCode}</td>
                                <td style={{ border: '1px solid #5A5A5A' }}>{quantity}</td>
                                <td style={{ border: '1px solid #5A5A5A' }}>{invoiceDetails}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table
                        cellPadding="8"
                        cellSpacing="0"
                        style={{
                            width: '100%',
                            textTransform: "capitalize",
                            fontSize: "10px",
                            borderCollapse: 'collapse',
                            border: '1px solid #5A5A5A',
                            verticalAlign: "top",
                            borderTop: '0'
                        }}
                    >

                        <tbody style={{ verticalAlign: "top" }}>
                            <tr >
                                <td style={{ width: '50%', border: '1px solid #5A5A5A', borderTop: '0' }}>
                                    <div style={{ height: "150px" }}>
                                        <span>11. declaration of the exporter</span><br />
                                        <span>The undersigned hereby declares that the above details and statements are correct, that the goods were produced in ({companyCountry}) and that
                                            they comply with the rules of origin of the People's Republic of ({companyCountry}).
                                        </span>
                                    </div>
                                    <div>
                                        <hr style={{ border: 'none', borderTop: '1px dotted #5A5A5A' }} />
                                        <span style={{ fontSize: "10px" }} >Place and date. signature and stamp of Authorized signatory </span>
                                    </div>
                                </td>
                                <td style={{ width: '50%', border: '1px solid #5A5A5A', borderTop: '0' }}>
                                    <div style={{ height: "150px" }}>
                                        <span>12. certification </span> <br />
                                        <span>It is hereby certified that the declaration by the exporter is correct.
                                        </span>
                                        <br />
                                        <Box
                                            component="img"
                                            src={Signature}

                                            style={{
                                                maxWidth: '100px',
                                                width: '100%',
                                                height: Signature ? 'auto' : '100px',
                                                marginBottom: 1
                                            }}
                                        />
                                        <br />
                                    </div>
                                    <hr style={{ border: 'none', borderTop: '1px dotted #5A5A5A' }} />
                                    <span style={{ fontSize: "10px" }} >Place and date. signature and stamp of certifying Authority</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div
                        component="footer"
                        style={{
                            display: footer ? 'block' : 'none',
                            width: '100%',
                            textAlign: 'center',
                            marginTop: '10px',
                            boxSizing: 'border-box',
                        }}
                    >
                        <Box
                            component="img"
                            src={companyFooter}

                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                objectFit: 'cover',
                            }}
                        />
                    </div>
                </div >
            </div >
        </>
    );
};

export {
    CooPrintFirst,
};
